/* EllipsesAnimation.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40keyframes%20k1w4xhaz%7B0%25%7Bopacity%3A0%7D24%25%7Bopacity%3A0%7D25%25%7Bopacity%3A1%7D99%25%7Bopacity%3A1%7Dto%7Bopacity%3A0%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2fBhteHasb%7Banimation%3Ak1w4xhaz%201.5s%20infinite%20forwards%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40keyframes%20k1iz2f8l%7B0%25%7Bopacity%3A0%7D49%25%7Bopacity%3A0%7D50%25%7Bopacity%3A1%7D99%25%7Bopacity%3A1%7Dto%7Bopacity%3A0%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2fBhteVjaG%7Banimation%3Ak1iz2f8l%201.5s%20infinite%20forwards%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=%40keyframes%20kzhlxv2%7B0%25%7Bopacity%3A0%7D74%25%7Bopacity%3A0%7D75%25%7Bopacity%3A1%7D99%25%7Bopacity%3A1%7Dto%7Bopacity%3A0%7D%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2fBhtegMFr%7Banimation%3Akzhlxv2%201.5s%20infinite%20forwards%7D");
const animation = null;
const animation1 = null;
const animation2 = null;
const dot1 = null;
const dot2 = null;
const dot3 = null;
const animatedOpacity = null;
const EllipsesAnimation = ({
  isAnimated = true
}: {
  isAnimated?: boolean;
}): JSX.Element => {
  return <svg width="10" height="2" viewBox="0 0 10 2" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    className={ax([isAnimated && "", isAnimated && "_2fBhteHasb", isAnimated && animatedOpacity])} d="M0.0800781 2V0.414062H1.67969V2H0.0800781Z" fill="#1868DB" />
			<path
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    className={ax([isAnimated && "", isAnimated && "_2fBhteVjaG", isAnimated && animatedOpacity])} d="M3.83984 2V0.414062H5.43945V2H3.83984Z" fill="#BF63F3" />
			<path
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    className={ax([isAnimated && "", isAnimated && "_2fBhtegMFr", isAnimated && animatedOpacity])} d="M7.59961 2V0.414062H9.19922V2H7.59961Z" fill="#FCA700" />
		</svg>;
};
export { EllipsesAnimation };